// 2-step login by email code (required for everyone). The server emails a 6-digit code after the password;
// "Remember this phone for 30 days" keeps a key on this phone only. See functions/src/loginCode.ts.
import { callServer } from './server';

const DEVICE_KEY = (uid: string) => `sc.device.${uid}`;
const SESSION_KEY = 'sc.session';

const read = (store: Storage | undefined, k: string) => { try { return store?.getItem(k) ?? ''; } catch { return ''; } };
const write = (store: Storage | undefined, k: string, v: string) => { try { store?.setItem(k, v); } catch { /* storage blocked */ } };

/** A random key for this browser tab, so unlocking the screen here doesn't need a new code. */
export function sessionKey(): string {
  let k = read(window.sessionStorage, SESSION_KEY);
  if (!k) {
    const b = new Uint8Array(24);
    crypto.getRandomValues(b);
    k = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    write(window.sessionStorage, SESSION_KEY, k);
  }
  return k;
}

export interface StartResult { done?: boolean; sentTo?: string }

/** After the password (or a screen unlock). Done straight away for a remembered phone; otherwise emails a code. */
export function startSecondStep(uid: string, prevAuthTime?: number): Promise<StartResult> {
  return callServer<StartResult>('startSecondStep', { deviceKey: read(window.localStorage, DEVICE_KEY(uid)), sessionKey: sessionKey(), ...(prevAuthTime ? { prevAuthTime } : {}) });
}

export async function finishSecondStep(uid: string, code: string, remember: boolean): Promise<void> {
  const r = await callServer<{ done: boolean; deviceKey?: string }>('finishSecondStep', { code, remember, sessionKey: sessionKey() });
  if (r.deviceKey) write(window.localStorage, DEVICE_KEY(uid), r.deviceKey);
}
